module.exports = __webpack_public_path__ + "static/media/Coins_Default@3x.b34b0cac.png";